export default __webpack_public_path__ + "static/kv-2-cd0ac08983defb70fd12494b38745bdd.png";